<template>
  <div class="l-history-nav" :style="{ '--theme-color': themeColor }">
    <el-tabs class="l-history-nav-tabs" v-model="activeName" type="card" :closable="list.length > 1" @tab-change="handleClick" @tab-remove="handleTabRemove" @contextmenu="handleContextmenu">
      <el-tab-pane v-for="(item) in list" :key="item.id" :label="item.name" :name="item.id + ''" />
    </el-tabs>
    <div class="l-history-nav-control" @click="$emit('clearAll')">
      <i class="iconfont icon-guanbi2fill"></i>
    </div>
    <contextMenu v-model:visible="contextmenuFlag" :x="contentmenuX" :y="contentmenuY">
      <contentMenuList :menulist="contextmenuList" @rowClick="contextmenuClick" />
    </contextMenu>
  </div>
</template>

<script>
import contextMenu from './contextMenu.vue'
import contentMenuList from './contextMenuList.vue'
export default {
  // 组件名称
  name: 'historyList',
  // 组件参数 接收来自父组件的数据
  props: {
    list: {
      type: Array,
      default: () => []
    },
    activeId: {
      type: Number,
      default: 0
    },
    themeColor: {
      type: String,
      default: '#4e86ff'
    }
  },
  // 局部注册的组件
  components: {
    contentMenuList,
    contextMenu
  },
  // 组件状态值
  data () {
    return {
      contextmenuFlag: false,
      contentmenuX: 0,
      contentmenuY: 0,
      contextmenuList: [
        { icon: 'arrow-left', title: '关闭左侧', value: 'left' },
        { icon: 'arrow-right', title: '关闭右侧', value: 'right' },
        { icon: 'times', title: '关闭其它', value: 'other' },
      ],
      tagName: '',
      activeName: ''
    }
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {
    activeId: {
      handler (val) {
        this.activeName = val + ''
      },
      immediate: true
    }
  },
  // 组件方法
  methods: {
    contextmenuClick(value) {
      const idx = this.list.findIndex(item => item.id === Number(this.tagName))
      const activeIdx = this.list.findIndex(item => item.id === this.activeId)
      let li = []
      const obj = { value, idx, activeIdx }
      if (value === 'left') {
        li = this.list.slice(idx)
      } else if (value === 'right') {
        li = this.list.slice(0, idx + 1)
      } else if (value === 'other') {
        li = this.list.filter(item => item.id === Number(this.tagName))
      }
      obj.li = li
      this.$emit('change-list', obj)
      this.contextmenuFlag = false
    },
    handleClick(tab) {
      const id = Number(tab)
      const item = this.list.find(item => item.id === id)
      this.$emit('clikHistory', item)
    },
    handleTabRemove(tab) {
      const id = Number(tab)
      const idx = this.list.findIndex(item => item.id === id)
      this.$emit('delHistory', idx)
    },
    handleContextmenu(event) {
      let target = event.target
      // fix https://github.com/d2-projects/d2-admin/issues/54
      let flag = false
      if (target.className.indexOf('el-tabs__item') > -1) flag = true
      else if (target.parentNode.className.indexOf('el-tabs__item') > -1) {
        target = target.parentNode
        flag = true
      }
      if (flag) {
        event.preventDefault()
        event.stopPropagation()
        this.contentmenuX = event.clientX
        this.contentmenuY = event.clientY
        this.tagName = target.getAttribute('aria-controls').slice(5)
        this.contextmenuFlag = true
      }
    },
  },
}
  </script> 

<style scoped lang="scss">
.l-history-nav {
  width: 100%;
  background-color: #fff;
  $themeColor: var(--theme-color);
  display: flex;
  overflow: hidden;
  min-height: 41px;
  ::v-deep &-tabs {
    flex: 1;
    overflow: auto;
    .el-tabs__header {
      margin-bottom: 0;
    }
    .el-tabs__item {
      color: #606266;
      font-weight: 400;
      background-color: rgba(0, 0, 0, .03);
      box-shadow: none !important;
      &:focus {
        box-shadow: none;
      }
    }
    .is-active {
      background-color: #fff;
      color: $themeColor;
    }
  }
  &-control {
    border-radius: 0px 6px 0px 0px;
    background-color: rgba(255, 255, 255, 0.55);
    border: 1px solid #CFD7E5;
    width: 54px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    i {
      font-size: 16px;
    }
  }
}
</style>
